const getItemStorage = (key) => {
  return localStorage.getItem(key);
};

const setItemStorage = (key, value) => {
  localStorage.setItem(key, value);
};

const removeItemStorage = (key) => {
  localStorage.removeItem(key);
};


export { getItemStorage, setItemStorage, removeItemStorage }